import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow, Tooltip, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import MapIcon from '@mui/icons-material/Map';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { usePages } from '../../../hooks/usePages';

import { DialogAgregarDomicilio } from '../../../dialogs/DialogAgregarDomicilio';
import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';
import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';

import { InputSearchButtonsStyle, InputSearchStyle } from '../../../styles/FormStyle';
import { TablePaddingStyle, TableTheadStyle } from '../../../styles/TableStyle';

import { ObtenerFormaNotificacion } from '../../../connections/catalogos/FormaNotificacionConnection';
import { ObtenerTipoNotificacion } from '../../../connections/catalogos/TipoNotificacionConnection';
import { ObtenerTipoParte } from '../../../connections/catalogos/TipoParteConnection';
import { GuardarNotificaciones } from '../../../connections/sentencia/SentenciaConnection';

import { TipoParteProps } from '../../../interfaces/catalogos/TipoParteInterface';
import { TipoNotificacionProps } from '../../../interfaces/catalogos/TipoNotificacionInterface';
import { FormaNotificacionProps } from '../../../interfaces/catalogos/FormaNotificacionInterface';
import { DomicilioProps } from '../../../interfaces/comun/DomicilioInterface';
import { defaultPersonaBusqueda, PersonaBusquedaProps } from '../../../interfaces/comun/PersonaInterface';
import { defaultParte, ParteProps } from '../../../interfaces/recepcion/ParteInterface';
import { defaultNotificacion } from '../../../interfaces/tribunal/AcuerdoInterface';
import { NotificacionesProps } from '../../../interfaces/notificaciones/NotificacionesInterface';
import { SentenciaProps } from '../../../interfaces/sentencia/SentenciaInterface';

type TipoParteType = '' | 'Actor/Demandado' | 'Otro';

interface Props {
    sentencia?:              SentenciaProps;
    edit?:                   boolean;
    notificaciones?:         NotificacionesProps[];
    setNotificaciones?:      React.Dispatch<React.SetStateAction<NotificacionesProps[]>>;
}

export const Notificacion = ( { notificaciones = [], edit = true, setNotificaciones, sentencia }: Props ) => {

    const dispatch = useDispatch();

    const [loadingGuardarNotificaciones, setLoadingGuardarNotificaciones] = useState( false );

    const [openDialogNuevaPersona, setOpenDialogNuevaPersona] = useState( false );
    const [openDialogBuscarPersona, setOpenDialogBuscarPersona] = useState( false );

    const [openAgregarDomicilio, setOpenAgregarDomicilio] = useState( false );
    const [openConfirmacion, setOpenConfirmacion] = useState( false );

    const [tipoParteNotificar, setTipoParteNotificar] = useState<TipoParteType>( 'Actor/Demandado' );

    const [personaBusqueda, setPersonaBusqueda] = useState<PersonaBusquedaProps>( defaultPersonaBusqueda );

    const [tipoNotificacion, setTipoNotificacion] = useState( 0 );
    const [tipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] );

    const [formaNotificacion, setFormaNotificacion] = useState( 0 );
    const [formaNotificacionArray, setFormaNotificacionArray] = useState<FormaNotificacionProps[]>( [] );

    const [tipoParte, setTipoParte] = useState( 0 );
    const [tipoParteArray, setTipoParteArray] = useState<TipoParteProps[]>( [] );

    const [parte, setParte] = useState( 0 );
    const [partesArray, setPartesArray] = useState<ParteProps[]>( [] );

    const [notificacionSelected, setNotificacionSelected] = useState<NotificacionesProps>( defaultNotificacion );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 10 );

    const { idPersona, nombreCompleto } = personaBusqueda;

    const seleccionarPersona = ( persona: PersonaBusquedaProps ) => setPersonaBusqueda( persona );

    const isAgregarDisabled = tipoParteNotificar === 'Otro' ? idPersona === 0 || tipoParte === 0 || tipoNotificacion === 0 || formaNotificacion === 0 : parte === 0 || tipoNotificacion === 0 || formaNotificacion === 0;
    const isGuardarDisabled = notificaciones.some(({ idFormaNotificacion, idTipoNotificacion, idDomicilio }) => idFormaNotificacion !== 2 && idTipoNotificacion !== 3 && idDomicilio === 0 );

    const handleAgregar = () => {

        if ( !setNotificaciones ) return;

        const id = `${new Date().getUTCSeconds()}${new Date().getUTCMilliseconds()}`;

        const tipoNotificacionFind = tipoNotificacionArray.find(({ idTipoNotificacion }) => idTipoNotificacion === tipoNotificacion)?.descripcion ?? '';
        const formaNotificacionFind = formaNotificacionArray.find(({ idFormaNotificacion }) => idFormaNotificacion === formaNotificacion)?.descripcion ?? '';

        const baseNotificacion = {
            idNotificacion:     parseInt( id) ,
            idTipoNotificacion: tipoNotificacion,
            tipoNotificacion:   tipoNotificacionFind,
            idFormaNotificacion: formaNotificacion,
            formaNotificacion:  formaNotificacionFind,
            idDomicilio:        0,
            domicilio:          '',
            nuevaNotificacion:  true,
        };

        if ( tipoParteNotificar === 'Otro' ) {

            const existeNotificacion = notificaciones.some( n => n.idPersona === idPersona && n.idTipoNotificacion === tipoNotificacion );

            if ( existeNotificacion ) {

                dispatch( openSnackbar({ message: 'La persona ya se encuentra agregada', variant: 'warning' }) );
                return;
            }

            const tipoParteFind = tipoParteArray.find(({ idTipoParte }) => idTipoParte === tipoParte)?.descripcion ?? '';

            setNotificaciones([
                ...notificaciones,
                {
                    ...baseNotificacion,
                    idPersona,
                    persona:        nombreCompleto,
                    idTipoParte:    tipoParte,
                    tipoParte:      tipoParteFind,
                }
            ]);

        }
        else if ( parte !== 0 ) {

            const { idPersona, persona, idTipoParte, tipoParte } = partesArray.find(({ id }) => id === parte) ?? defaultParte;

            const existeNotificacion = notificaciones.some( n => n.idPersona === idPersona && n.idTipoNotificacion === tipoNotificacion );

            if ( existeNotificacion ) {
                dispatch( openSnackbar({ message: 'La persona ya se encuentra agregada', variant: 'warning' }) );
                return;
            }

            setNotificaciones([...notificaciones, {
                ...baseNotificacion,
                idPersona,
                persona,
                idTipoParte,
                tipoParte,
            }]);
        }

        resetForm();
    }

    const handleEliminar = () => {

        setNotificaciones?.( prev => prev.filter( ({ idNotificacion }) => idNotificacion !== notificacionSelected.idNotificacion ) );

        setNotificacionSelected( defaultNotificacion );
        setOpenConfirmacion( false );

    }

    const resetForm = () => {

        setTipoParteNotificar( 'Actor/Demandado' );
        setTipoNotificacion( 0 );
        setFormaNotificacion( 0 );
        setTipoParte( 0 );
        setParte( 0 );
        setPersonaBusqueda( defaultPersonaBusqueda );

    }

    const handleGuardarNotificaciones = async () => {

        setLoadingGuardarNotificaciones( true );

        await GuardarNotificaciones({ idSentencia: sentencia?.idSentencia ?? 0, notificaciones }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setLoadingGuardarNotificaciones( false );

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );

                }
                else {

                    setLoadingGuardarNotificaciones( false );

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleDomicilio = ( value: DomicilioProps ) => {

        const descripcionDomicilio = value.descripcion ?? "";
        const numeroDomicilio = value.numero?.toString() ?? "";
        const asentamiento = value.asentamiento?.descripcion ?? "";
        const codigoPostal = value.asentamiento?.codigoPostal ?? "";
        const municipio = value.asentamiento?.municipio?.descripcion ?? "";
        const estado = value.asentamiento?.estado?.descripcion ?? "";

        const domicilio = descripcionDomicilio + " #" + numeroDomicilio + ", Col. " + asentamiento + ", C.P " + codigoPostal + ", " + municipio + ", " + estado;

        const newArray = notificaciones.map( elem => {

            if ( elem.idPersona === notificacionSelected.idPersona ) {

                elem.idDomicilio = value.idDomicilio ?? 0;
                elem.domicilio = domicilio;

            }

            return elem;

        });

        setNotificaciones?.( newArray );

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoNotificacion().then( resp => {
                setTipoNotificacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerFormaNotificacion().then( resp => {
                setFormaNotificacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoParte().then( resp => {
                setTipoParteArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        if ( !sentencia?.idSentencia ) return;

        const { partes } = sentencia;

        /*const partes =
            amparo.idAmparo                     ? amparo.partes            :
            expediente.idExpediente             ? expediente.partes        :
            exhortoRecibido.idExhortoRecibido   ? exhortoRecibido.partes   :
            irregular.idIrregular               ? irregular.partes         :
            [];*/

        setPartesArray( partes );

    }, [ sentencia ] );

    return (
        <Box p={ 4 } component={ Paper }>

            <Grid container spacing={ 3 } mt={ 1 }>

                {
                    edit
                    &&
                        <>

                            <Grid size={{ xs: 12, md: 6 }}>

                                <FormControl required fullWidth>

                                    <InputLabel>Tipo de notificación</InputLabel>

                                    <Select
                                        label='Tipo de notificación'
                                        value={ tipoNotificacion }
                                        onChange={ (e) => setTipoNotificacion( e.target.value ) }
                                    >
                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            tipoNotificacionArray
                                            .filter( ({ idTipoNotificacion }) => idTipoNotificacion !== 3 )
                                            .map( ({ idTipoNotificacion, descripcion }) => (
                                                <MenuItem key={ idTipoNotificacion } value={ idTipoNotificacion }>{ descripcion }</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>

                                <FormControl required fullWidth>

                                    <InputLabel>Forma de notificación</InputLabel>

                                    <Select
                                        label='Forma de notificación'
                                        value={ formaNotificacion }
                                        onChange={ (e) => setFormaNotificacion( e.target.value ) }
                                        disabled={ tipoNotificacion === 0 }
                                    >
                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            formaNotificacionArray
                                            .filter(({ idFormaNotificacion }) => ( tipoNotificacion !== 1 && idFormaNotificacion !== 3 ) || idFormaNotificacion === 1)
                                            .map( ({ idFormaNotificacion, descripcion }) => (
                                                <MenuItem key={ idFormaNotificacion } value={ idFormaNotificacion }>{ descripcion }</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 12, xs: 12 }}>

                                <FormControl>

                                    <FormLabel>Selecciona el tipo de parte a notificar:</FormLabel>
                                    <RadioGroup row>

                                        <FormControlLabel
                                            label='Actor/Demandado'
                                            control={ <Radio checked={ tipoParteNotificar === 'Actor/Demandado' }
                                            onChange={ () => { setTipoParteNotificar('Actor/Demandado'); setParte( 0 ); setPersonaBusqueda( defaultPersonaBusqueda ); } }/>}
                                        />

                                        <FormControlLabel
                                            label='Otro'
                                            control={ <Radio checked={ tipoParteNotificar === 'Otro' }
                                            onChange={ () => { setTipoParteNotificar('Otro'); setParte( 0 ); setPersonaBusqueda( defaultPersonaBusqueda ); } } />}
                                        />

                                    </RadioGroup>

                                </FormControl>

                            </Grid>

                            {
                                tipoParteNotificar === 'Actor/Demandado'
                                &&
                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <FormControl required fullWidth>

                                            <InputLabel>Seleccione una persona a notificar</InputLabel>

                                            <Select
                                                label='Seleccione una persona a notificar'
                                                value={ parte }
                                                onChange={ (e) => setParte( e.target.value ) }
                                                renderValue={( selected ) => {
                                                    if ( selected === 0 ) return 'Selecciona una opción';

                                                    const { persona } = partesArray.find(u => u.id === selected) ?? defaultParte;

                                                    return persona;
                                                }}
                                            >
                                                <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                {
                                                    partesArray.map( ({ id, persona, tipoParte}) => (

                                                        <MenuItem key={ id } value={ id }>

                                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                                                                <Typography variant="body1">{ persona }</Typography>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    <strong>({ tipoParte })</strong>
                                                                </Typography>

                                                            </Box>

                                                        </MenuItem>

                                                    ))
                                                }
                                            </Select>

                                        </FormControl>

                                    </Grid>
                            }

                            {
                                tipoParteNotificar === 'Otro'
                                &&
                                    <>

                                        <Grid size={{ md: 8, xs: 12 }} >

                                            <Paper component='div' sx={ InputSearchStyle } >

                                                <InputBase
                                                    sx={{ ml: 1, flex: 1 }}
                                                    inputProps={{ 'aria-label': 'Buscar persona' }}
                                                    placeholder='Buscar persona'
                                                    value={ nombreCompleto }
                                                    onChange={ () => {} }
                                                    autoComplete='off'
                                                    disabled
                                                />

                                                <Button
                                                    size='small'
                                                    variant='contained'
                                                    sx={ InputSearchButtonsStyle }
                                                    onClick={ () => setOpenDialogBuscarPersona( true ) }
                                                >
                                                    <SearchIcon />
                                                </Button>

                                                <Button
                                                    variant='contained'
                                                    size='small'
                                                    sx={ InputSearchButtonsStyle }
                                                    onClick={ () => setOpenDialogNuevaPersona( true ) }
                                                >
                                                    <PersonAddIcon />
                                                </Button>

                                            </Paper>

                                        </Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <FormControl required fullWidth>

                                                <InputLabel>Tipo de parte</InputLabel>

                                                <Select
                                                    label='Tipo de parte'
                                                    value={ tipoParte }
                                                    onChange={ (e) => setTipoParte( e.target.value ) }
                                                    disabled={ idPersona === 0 }
                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                    {
                                                        tipoParteArray
                                                        .filter( ({ idTipoParte }) => idTipoParte === 1 || idTipoParte === 2 || idTipoParte === 7 || idTipoParte === 8 )
                                                        .map( ({ idTipoParte, descripcion }) => (
                                                            <MenuItem key={ idTipoParte } value={ idTipoParte }>{ descripcion }</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                    </>
                            }

                            <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                                <Button
                                    variant='contained'
                                    sx={{ width: { md: 260, xs: '100%' } }}
                                    onClick={ handleAgregar }
                                    disabled={ isAgregarDisabled }
                                >
                                    Agregar
                                </Button>

                            </Grid>

                        </>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }}>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Tipo de notificación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}>Persona a notificar</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}>Domicilio a notificar</TableCell>

                                    { edit && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell> }

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    (
                                        rowsPerPage > 0
                                        ?
                                            notificaciones.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                        :
                                            notificaciones
                                    ).map( ( notificacion, index ) => {

                                        const { tipoNotificacion, idFormaNotificacion, formaNotificacion, persona, tipoParte, domicilio } = notificacion;

                                        return <TableRow key={ index } >

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ tipoNotificacion }</strong>
                                                </Typography>

                                                <Typography variant='subtitle2' color='text.secondary'>
                                                    ({ formaNotificacion })
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant="subtitle1">
                                                    <strong>{ persona.toUpperCase() }</strong>
                                                </Typography>

                                                <Typography variant='subtitle2' color='text.secondary'>
                                                    ({ tipoParte })
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' color='text.secondary'>
                                                    <strong>{ domicilio }</strong>
                                                </Typography>

                                            </TableCell>

                                            {
                                                edit
                                                &&
                                                    <TableCell sx={{ textAlign: 'end' }}>

                                                        <Tooltip title='Eliminar notificación'>

                                                            <IconButton
                                                                color='primary'
                                                                onClick={ () => { setNotificacionSelected( notificacion ); setOpenConfirmacion( true ); }}
                                                                sx={{ mr: 1 }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>

                                                        </Tooltip>

                                                        <Tooltip title='Agregar domicilio'>

                                                            <IconButton
                                                                color='primary'
                                                                disabled={ idFormaNotificacion === 2 }
                                                                onClick={ () => { setNotificacionSelected( notificacion ); setOpenAgregarDomicilio( true ); }}
                                                            >
                                                                <MapIcon />
                                                            </IconButton>

                                                        </Tooltip>

                                                    </TableCell>
                                            }

                                        </TableRow>

                                    })
                                }

                                {
                                    notificaciones.length === 0
                                    &&
                                        <TableRow>

                                            <TableCell
                                                colSpan={ 7 }
                                                align="center"
                                            >
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 1 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { notificaciones.length } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 3 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ notificaciones.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right'}}> </Grid>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center'}}>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        disabled={ isGuardarDisabled }
                                        loading={ loadingGuardarNotificaciones }
                                        onClick={ handleGuardarNotificaciones }
                                    >
                                        Guardar notificaciones
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'left' }}> </Grid>

                            </Grid>

                        </Grid>
                }

            </Grid>

            <DialogNuevaPersona
                openDialog={ openDialogNuevaPersona }
                handleCloseDialog={ () => setOpenDialogNuevaPersona( false ) }
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona }
                handleCloseDialog={ () => setOpenDialogBuscarPersona( false ) }
                seleccionarPersona={ seleccionarPersona }
            />

            <Dialog
                maxWidth='sm'
                fullWidth
                open={ openConfirmacion }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea quitar el registro seleccionado?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>
                    <Button onClick={ () => { setNotificacionSelected( defaultNotificacion ); setOpenConfirmacion( false ); }}> Cancelar </Button>
                    <Button onClick={ handleEliminar } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

            <DialogAgregarDomicilio
                openDialog={ openAgregarDomicilio }
                idPersona={ notificacionSelected.idPersona }
                idDomicilio={ notificacionSelected.idDomicilio }
                SeleccionarDomicilio={ handleDomicilio }
                handleCloseDialog={ () => setOpenAgregarDomicilio( false ) }
            />

        </Box>
    )
}
